import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import RankingChart from '@/views/dashboard/_components/ranking-chart/ranking-chart.vue'
import type { BaselineCategoryTopItem } from '@/views/dashboard/safe-status/base-line/_components/base-line-header/base-line-header.service'


export default /*#__PURE__*/_defineComponent({
  __name: 'baseline-category-bar-chart',
  props: {
    data: { default: () => [] },
    loading: { type: Boolean, default: false },
    onViewMore: { type: Function, default: undefined }
  },
  emits: ["categoryClick"],
  setup(__props: any, { emit: __emit }) {

const emit = __emit

const props = __props

const { t, locale } = useI18n()

const rankingCardOpt = computed(() => {
  void locale.value
  return {
    onViewMore: props.onViewMore,
    viewMoreText: t('baselineDashboard.viewMore')
  }
})

const chartData = computed(() =>
  (props.data || [])
    .filter(d => (d.terminal_count || 0) > 0)
    .map(d => ({
      name: d.category_name,
      count: d.terminal_count || 0,
      check_item_id: d.check_item_id,
      category_name: d.category_name,
      terminal_count: d.terminal_count
    }))
)

const rowClickable = computed(() =>
  chartData.value.some(d => !!d.check_item_id)
)

function onRankingItemClick (item: {
  check_item_id?: string
  category_name?: string
  name?: string
  terminal_count?: number
  count?: number
}) {
  if (!item.check_item_id) return
  emit('categoryClick', {
    check_item_id: item.check_item_id,
    category_name: item.category_name ?? item.name ?? '',
    terminal_count: item.terminal_count ?? item.count ?? 0
  })
}

return (_ctx: any,_cache: any) => {
  const _component_el_tag = _resolveComponent("el-tag")!

  return (_openBlock(), _createBlock(RankingChart, {
    title: _ctx.$t('baselineDashboard.chartCategoryTop5'),
    data: chartData.value,
    "show-time-range": false,
    unit: _ctx.$t('baselineDashboard.unitItems'),
    "name-key": "name",
    "max-items": 5,
    "card-size": "second",
    loading: _ctx.loading,
    "card-opt": rankingCardOpt.value,
    "row-clickable": rowClickable.value,
    onItemClick: onRankingItemClick
  }, {
    titleAfter: _withCtx(() => [
      _createVNode(_component_el_tag, {
        size: "small",
        type: "primary"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.rankTagTop5')), 1)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["title", "data", "unit", "loading", "card-opt", "row-clickable"]))
}
}

})